var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMobileNumber01 = function SvgIconMobileNumber01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_mobile_number-01_svg2__a",
    x1: -4.71,
    x2: 84.84,
    y1: 73.66,
    y2: 34.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M72.29 0H27.71C24 0 20.96 3.04 20.96 6.75v86.49c0 3.72 3.04 6.76 6.75 6.76h44.58c3.71 0 6.75-3.03 6.75-6.75V6.75C79.04 3.03 76 0 72.29 0M42.87 4.87h14.26c.45 0 .82.37.82.82s-.37.82-.82.82H42.87c-.45 0-.82-.37-.82-.82s.37-.82.82-.82M50 96.62c-1.87 0-3.38-1.51-3.38-3.38s1.51-3.38 3.38-3.38 3.38 1.51 3.38 3.38-1.51 3.38-3.38 3.38m24.35-9.12h-48.7V10.71h48.69V87.5Z",
    style: {
      fill: "url(#icon_mobile_number-01_svg2__a)"
    }
  }));
};
export default SvgIconMobileNumber01;